import * as Sentry from '@sentry/nextjs';
import { NextPage, NextPageContext } from 'next';
import Error from 'next/error';
import router from 'next/router';
import React from 'react';

interface SentryCaptureErrorComponentProps {
  statusCode: number;
}

const SentryCaptureErrorComponent: NextPage<
  SentryCaptureErrorComponentProps
> = ({ statusCode }) => {
  if (typeof window !== 'undefined') {
    if (statusCode === 404 || statusCode === 500) {
      router.replace(`/${statusCode}`);
      return null;
    }
  }
  return <Error statusCode={statusCode} />;
};

SentryCaptureErrorComponent.getInitialProps = async (
  contextData: NextPageContext
) => {
  await Sentry.captureUnderscoreErrorException(contextData);
  return Error.getInitialProps(contextData);
};

export default SentryCaptureErrorComponent;
